import { createSvgIcon } from '@mui/material/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var CheckBubbleIcon = createSvgIcon( /*#__PURE__*/_jsxs(_Fragment, {
  children: [/*#__PURE__*/_jsx("path", {
    d: "M10.24,3h3.52A8.24,8.24,0,0,1,22,11.24v0A7.76,7.76,0,0,1,14.24,19H9.76A7.76,7.76,0,0,1,2,11.24v0A8.24,8.24,0,0,1,10.24,3Z"
  }), /*#__PURE__*/_jsx("path", {
    d: "M5,17v3.5a.5.5,0,0,0,.85.35L9,17Z"
  }), /*#__PURE__*/_jsx("path", {
    d: "M16.76,9.17l-5.41,5.4a.82.82,0,0,1-1.16,0L7.24,11.64a.83.83,0,1,1,1.17-1.17l2.36,2.36L15.59,8a.83.83,0,0,1,1.17,1.17Z",
    fill: "#fff"
  })]
}), 'CheckBubbleIcon');